import { createFileRoute } from "@tanstack/react-router";
import { MarketingContentPage } from "../components/marketing/MarketingContentPage";
import { contentHead, loadContentPage } from "../marketing-content/load";

export const Route = createFileRoute("/compare")({
  loader: () => loadContentPage("/compare"),
  head: ({ loaderData }) => contentHead(loaderData),
  component: ContentRoute,
});
function ContentRoute() {
  return <MarketingContentPage page={Route.useLoaderData()} />;
}
